// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"RoomModal_checkboxContainer__D3qwp"};